import styled from 'styled-components';
import { white, contiOrange } from '../../style/colors';

export const Card = styled.div`
  background: ${white};
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  gap: 20px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: ${contiOrange};
  }

  @media (max-width: 640px) {
    padding: 16px;
    gap: 16px;
  }
`;

export const IconWrapper = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(255, 165, 0, 0.1) 0%, rgba(255, 165, 0, 0.05) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    font-size: 28px;
    color: ${contiOrange};
  }

  @media (max-width: 640px) {
    width: 48px;
    height: 48px;

    i {
      font-size: 24px;
    }
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled.div`
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const Value = styled.div`
  font-size: 28px;
  color: #111827;
  font-weight: 700;
  line-height: 1;

  @media (max-width: 640px) {
    font-size: 24px;
  }
`;

export const TrendIndicator = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: ${props => props.positive ? '#10b981' : '#ef4444'};
  margin-top: 4px;

  i {
    font-size: 14px;
  }
`;

